import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Laptop = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M2.79 3.738h10.423a1.08 1.08 0 0 1 1.077 1.078v8.189a.333.333 0 0 1-.333.333H2.047a.333.333 0 0 1-.334-.333v-8.19A1.079 1.079 0 0 1 2.79 3.739Zm10.834 8.933V4.816a.411.411 0 0 0-.411-.411H2.79a.412.412 0 0 0-.411.41v7.856h11.244Z" />
      <path
        d="M1.714 12.527c0-.184.149-.334.333-.334h11.91a.333.333 0 0 1 .301.478h1.188a.333.333 0 0 1 0 .667H.558a.333.333 0 0 1 0-.667h1.189a.332.332 0 0 1-.033-.144Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

Laptop.category = 'product-category';

Laptop.displayName = 'Laptop';
